export default () => {
  // Navigation: sub sub navigation
  $('.subsub-navigation').on('click', '.subsub-navigation-group > a', function (event) {
    event.preventDefault();

    var $this = $(this);

    $this.parent().siblings().removeClass('open');
    $this.parent().toggleClass('open');
  });

  let toggleClosestLi = (event) => {
    event.preventDefault();
    event.target.closest('ul').querySelectorAll('li.has-active').forEach((li) => li.classList.remove('has-active'))
    event.target.closest('li').classList.toggle('open');
    if (event.target.closest('li level0')) {
      event.target.closest('li level0').classList.add('has-active');
    }
  }

  document.querySelectorAll('.subsub-navigation .parent').forEach((el) => {
    let navigation = el.closest('.subsub-navigation');
    navigation.querySelectorAll('.level0.parent.active, .level1.parent.active').forEach((levelEl) => {
      $(levelEl).add($(navigation).find('.level0.parent.has-active, .level1.parent.has-active')).addClass('open');
    })

    navigation.querySelectorAll('.parent > a[href="#"]').forEach((link) => {
      link.closest('li a').removeEventListener('click', toggleClosestLi);
      link.closest('li a').addEventListener('click', toggleClosestLi);
    });
  });

  // Navigation: responsive content navigation
  document.querySelectorAll('.content-navigation .content-navigation-toggle').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      el.closest('.content-navigation').classList.toggle('open');
    });
  });
};
